export const getBatchPropsForSubmit = (props) => ({
  batchProcessViewPrimaryKey: props.batchProcessViewPrimaryKey || '',
  batchProcessParentEntityName: props.batchProcessParentEntityName || '',
  batchProcessEntityRecordInstanceId: props.batchProcessEntityRecordInstanceId || '',
  batchProcessChildRecordInstanceId: props.batchProcessChildRecordInstanceId || '',
  batchProcessUpdatedEntityName: props.batchProcessUpdatedEntityName || '',
  batchProcessUpdatedPrimaryKey: props.batchProcessUpdatedPrimaryKey || '',
  batchProcessUpdatedPrimaryKeyValue: props.batchProcessUpdatedPrimaryKeyValue || '',
  batchProcessUpdatedUserCode: props.batchProcessUpdatedUserCode || '',
  batchProcessUpdatedStatusCode: props.batchProcessUpdatedStatusCode || '',
  batchProcessUpdatedModifedDate: props.batchProcessUpdatedModifedDate || '',
  batchProcessContainerWorkflowKey: props.batchProcessContainerWorkflowKey || '',
  batchProcessWorkflowKey: props.batchProcessWorkflowKey || '',
  batchProcessWorkflowInstanceId: props.batchProcessWorkflowInstanceId || '',
  batchProcessWorkflowStepInstanceId: props.batchProcessWorkflowStepInstanceId || '',
  batchProcessParentWorkflowInstanceId: props.batchProcessParentWorkflowInstanceId || '',
  batchProcessWorkflowStepName: props.batchProcessWorkflowStepName || '',
  batchProcessView: props.batchProcessView || '',
});
